import {
    postData,
    getData,
    patchData,
    deleteData
} from './Services'

export const getPoliticaRegistro = async () => {
  const res = await getData('/politicas/registro-gps');
  return res;
};
// ── Zonas por ubicación GPS ──
export const getZonasPorUbicacion = async (latitud, longitud) => {
  const res = await getData(`/zonasEntregas/por-ubicacion?latitud=${latitud}&longitud=${longitud}`);
  return res;
};
 
// ── Asignar zona por GPS al registrar ──
export const asignarZonaPorGps = async (user_id, latitud, longitud) => {
  const res = await postData('/clientesZonas/asignar-por-gps', { user_id, latitud, longitud });
  return res;
};
 